import { render, staticRenderFns } from "./dp-select.vue?vue&type=template&id=6ba07d7a&scoped=true"
import script from "./dp-select.vue?vue&type=script&lang=js"
export * from "./dp-select.vue?vue&type=script&lang=js"
import style0 from "./dp-select.vue?vue&type=style&index=0&id=6ba07d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba07d7a",
  null
  
)

export default component.exports